import { Card, TableContainer, Alert, Table, TableHead, TableRow, TableCell } from '@mui/material';
import NodataImage from './NoDataImg.png'

const NoDataAvailable = () => {
  return (
    <>
      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <img
                    alt="No Data Found"
                    src={NodataImage}
                    width={250}
                    height={250}
                    style={{ mixBlendMode: 'darken' }}
                    className='no-data-available'
                  />
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      </Card>
    </>
  );
};

export default NoDataAvailable;
